<template>
  <BaseReferenceTable
    title="Языки"
    entity-name="Язык"
    :headers="headers"
    :api="api"
    no-data-icon="mdi-web"
    no-data-text="Языки не найдены"
    @load-data="loadData"
    @create-item="createItem"
    @update-item="updateItem"
    @delete-item="deleteItem"
  >
    <!-- Form fields for create/edit dialog -->
    <template #form-fields="{ item, editMode }">
      <v-text-field
        v-model="item.code"
        label="Код языка"
        placeholder="ru, en, de..."
        :rules="codeRules"
        :disabled="editMode"
        required
        density="compact"
        class="mb-3"
      ></v-text-field>
      
      <v-text-field
        v-model="item.name"
        label="Название языка"
        placeholder="Русский, English, Deutsch..."
        :rules="nameRules"
        required
        density="compact"
      ></v-text-field>
    </template>

    <!-- Custom table columns -->
    <!-- Language code with flag -->
    <template v-slot:[`item.code`]="{ item }">
      <div class="d-flex align-center">
        <v-chip
          :color="getLanguageColor(item.code)"
          variant="outlined"
          size="small"
          class="mr-2"
        >
          {{ item.code.toUpperCase() }}
        </v-chip>
      </div>
    </template>

    <!-- Language name -->
    <template v-slot:[`item.name`]="{ item }">
      <span class="font-weight-medium">{{ item.name }}</span>
    </template>
  </BaseReferenceTable>
</template>

<script>
// import { ref } from 'vue' // убрано - не используется
import BaseReferenceTable from './BaseReferenceTable.vue'
import { referenceApi } from '@/services/api/referenceApi'

export default {
  name: 'LanguagesTable',
  components: {
    BaseReferenceTable
  },
  setup() {
    const api = referenceApi

    const headers = [
      { 
        title: 'Код', 
        key: 'code', 
        sortable: true, 
        width: 120 
      },
      { 
        title: 'Название', 
        key: 'name', 
        sortable: true 
      }
    ]

    // Validation rules
    const codeRules = [
      v => !!v || 'Код языка обязателен',
      v => (v && v.length >= 2 && v.length <= 10) || 'Код должен содержать от 2 до 10 символов',
      v => /^[a-z]+$/.test(v) || 'Код должен содержать только строчные латинские буквы'
    ]

    const nameRules = [
      v => !!v || 'Название языка обязательно',
      v => (v && v.length >= 1 && v.length <= 100) || 'Название должно содержать от 1 до 100 символов'
    ]

    // Methods
    const loadData = async ({ page, limit, callback }) => {
      try {
        const skip = (page - 1) * limit
        const response = await api.getLanguages({ skip, limit })
        callback(response.data)
      } catch (error) {
        console.error('Error loading languages:', error)
        callback(null, 'Ошибка загрузки языков. Проверьте подключение к серверу.')
      }
    }

    const createItem = async ({ item, callback }) => {
      try {
        await api.createLanguage(item)
        callback(true)
      } catch (error) {
        console.error('Error creating language:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось создать язык'
        callback(false, message)
      }
    }

    const updateItem = async ({ item, callback }) => {
      try {
        await api.updateLanguage(item.id, item)
        callback(true)
      } catch (error) {
        console.error('Error updating language:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось обновить язык'
        callback(false, message)
      }
    }

    const deleteItem = async ({ ids, callback }) => {
      try {
        await Promise.all(ids.map(id => api.deleteLanguage(id)))
        callback(true)
      } catch (error) {
        console.error('Error deleting languages:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось удалить языки'
        callback(false, message)
      }
    }

    const getLanguageColor = (code) => {
      const colors = {
        'ru': 'blue',
        'en': 'green',
        'de': 'orange',
        'fr': 'purple',
        'es': 'red',
        'it': 'teal',
        'zh': 'indigo',
        'ja': 'pink',
        'ko': 'cyan',
        'ar': 'amber'
      }
      return colors[code] || 'grey'
    }

    return {
      api,
      headers,
      codeRules,
      nameRules,
      loadData,
      createItem,
      updateItem,
      deleteItem,
      getLanguageColor
    }
  }
}
</script>